import type { YouTubeDestinationPlatformData } from './destination-details.interfaces';

/** Per-publication YouTube override stored in publish_metadata_overrides_json.destinationSettings. */
export type YouTubePublicationSettings = YouTubeDestinationPlatformData;

const DEFAULT_PRIVACY = 'Private';

export function mapYouTubeDefaultsToPublicationSettings(
  defaults: YouTubeDestinationPlatformData | null | undefined,
): YouTubePublicationSettings {
  return {
    privacy: defaults?.privacy ?? DEFAULT_PRIVACY,
    self_declared_made_for_kids: defaults?.self_declared_made_for_kids ?? false,
    notify_subscribers: defaults?.notify_subscribers ?? false,
    category_id: defaults?.category_id ?? null,
  };
}

export function normalizeYouTubePublicationSettings(
  settings: YouTubePublicationSettings,
): YouTubePublicationSettings {
  return {
    privacy: settings.privacy?.trim() || DEFAULT_PRIVACY,
    self_declared_made_for_kids: settings.self_declared_made_for_kids ?? false,
    notify_subscribers: settings.notify_subscribers ?? false,
    category_id: settings.category_id ?? null,
  };
}

/** Merges saved override with destination defaults (same pattern as Instagram/Facebook). */
export function resolveYouTubePublicationSettings(
  saved: unknown,
  defaults: YouTubeDestinationPlatformData | null | undefined,
): YouTubePublicationSettings {
  if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
    const obj = saved as Record<string, unknown>;
    if (
      'privacy' in obj ||
      'category_id' in obj ||
      'self_declared_made_for_kids' in obj ||
      'notify_subscribers' in obj
    ) {
      return normalizeYouTubePublicationSettings({
        privacy: (obj.privacy as string | null) ?? null,
        self_declared_made_for_kids:
          obj.self_declared_made_for_kids as boolean | null | undefined,
        notify_subscribers: obj.notify_subscribers as boolean | null | undefined,
        category_id: (obj.category_id as string | null) ?? null,
      });
    }
  }
  return mapYouTubeDefaultsToPublicationSettings(defaults);
}
